import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { GrowlMessage } from '@campgladiator/cgui-core.molecules.growl-message'
import { Progress, CheckinCounter, HealthStatForm, StatsHistory } from '../'
import { getChallengesProgress } from '../../../redux/features/challengeActions'

const Dashboard = () => {
  const dispatch = useDispatch()
  const [areStatsSubmitted, setAreStatsSubmitted] = useState(false)
  const [statSubmissionMessage, setStatSubmissionMessage] = useState('')
  const [statSubmissionMessageTitle, setStatSubmissionMessageTitle] =
    useState('')
  const { user } = useSelector((state) => state.authReducer)
  const { activeChallenge, challenges, isRegisteredForActiveFit } = useSelector(
    (state) => state.challengeReducer,
  )

  const handleOnSubmitStats = (isError) => {
    setAreStatsSubmitted(true)
    setStatSubmissionMessage(
      isError
        ? 'Please try submitting your stats again - making sure you only submit each stat once per day'
        : 'Stats submitted successfully',
    )
    setStatSubmissionMessageTitle(isError ? 'Error' : 'Success')
    !isError && getLatestStats()
  }

  const getLatestStats = useCallback(() => {
    dispatch(getChallengesProgress())
  }, [dispatch])

  useEffect(() => {
    getLatestStats()
  }, [getLatestStats])

  return (
    <div className="dashboard">
      <GrowlMessage
        isVisible={areStatsSubmitted}
        title={statSubmissionMessageTitle}
        autoClose
        onClick={() => setAreStatsSubmitted(false)}
      >
        {statSubmissionMessage}
      </GrowlMessage>
      <Progress
        challenge={activeChallenge}
        user={user}
        isFitChallengeActive={isRegisteredForActiveFit}
      />
      {!!isRegisteredForActiveFit && (
        <div className="checkin">
          <CheckinCounter
            user={user}
            totalCheckIns={activeChallenge?.checkins}
            minCheckIns={activeChallenge?.goal}
          />
        </div>
      )}
      <section className="split">
        {isRegisteredForActiveFit && (
          <div className="submit-stats">
            <HealthStatForm onSubmit={handleOnSubmitStats} />
          </div>
        )}
        <div className="history">
          <StatsHistory challenges={challenges} />
        </div>
      </section>
    </div>
  )
}

export default Dashboard
